"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withTimeout = _interopRequireDefault(require("./withTimeout"));

var _CircularProgress = _interopRequireDefault(require("@eig-builder/core-ui/CircularProgress"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  position: absolute;\n  width: 100%;\n  padding-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Wrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.withPaddingY ? props.theme.spacing(4) + 'px' : 0;
});

var LoaderWithBackdrop = function LoaderWithBackdrop(props) {
  var wrapperClassNames = (0, _classnames["default"])('d-flex', {
    'justify-content-center': props.centeredX,
    'align-items-center': props.centeredY
  }, props.className);
  return _react["default"].createElement(Wrapper, {
    className: wrapperClassNames,
    withPaddingY: props.withPaddingY
  }, _react["default"].createElement(_CircularProgress["default"], null));
};

var _default = (0, _withTimeout["default"])(LoaderWithBackdrop);

exports["default"] = _default;
LoaderWithBackdrop.propTypes = {
  centeredX: _propTypes["default"].bool,
  centeredY: _propTypes["default"].bool,
  withPaddingY: _propTypes["default"].bool,
  className: _propTypes["default"].string
};